<template>
  <div class="pdfvuer-container fill-height ">
    <div v-show="isLoading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <pdf
      v-for="i in numPages"
      :id="i"
      :key="i"
      :src="pdfdata"
      :page="i"
      :scale.sync="scale"
      class="pdfvuer-container--pdf"
      :resize="true"
      @loading="loading = $event"
    >
    </pdf>
  </div>
</template>

<script>
import pdfvuer from "pdfvuer";

export default {
  components: {
    pdf: pdfvuer
  },

  props: {
    pdfUrl: {
      type: ArrayBuffer,
      required: true
    }
  },

  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      scale: "page-width",
      loading: true
    };
  },

  computed: {
    isLoading() {
      return !this.pdfUrl || this.loading;
    }
  },

  watch: {
    pdfUrl: "getPDF"
  },

  mounted() {
    return this.getPDF();
  },

  methods: {
    async getPDF() {
      if (this.pdfUrl && process.client) {
        this.pdfdata = pdfvuer.createLoadingTask(this.pdfUrl);
        this.numPages = (await this.pdfdata).numPages;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .pdfvuer-container {
    margin-left: auto;
    margin-right: auto;
    max-width: 66.6666666667%;
  }
}

.pdfvuer-container--pdf {
  width: 100%;
}
</style>
